import React from 'react';
import PropTypes from 'prop-types';
import { orderCollection } from 'Helpers/Utils';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Skeleton } from '@material-ui/lab';
import { Typography } from '@material-ui/core';
import { useAccordionListStateContext } from './AccordionListContext';
import Accordion from './Accordion';
import AccordionListHeader from './AccordionListHeader';
import AccordionListPagination from './AccordionListPagination';

const Placeholder = withStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: '1',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.dimensions.sm,
  },
  text: {
    fontSize: 24,
    fontWeight: theme.typography.fontWeightBold,
  },
}))(({ classes }) => {
  return (
    <div className={classes.root}>
      <Typography color="primary" className={classes.text}>{'Nothing to see here'}</Typography>
    </div>
  );
});
function AccordionList({
  AccordionContentComponent,
  AccordionContentProps,
  classes,
  placeholder,
}) {
  const { collection, order } = useAccordionListStateContext();
  const resources = collection && order?.attrName
    ? orderCollection(collection, order.attrName, order.direction)
    : collection?.resources().list();

  let Content = null;
  if (resources?.length) {
    Content = resources.map(r => {
      return (
        <Accordion
          key={r.id()}
          resource={r}
          ContentCompnent={AccordionContentComponent}
          ContentProps={AccordionContentProps}
        />
      );
    });
  } else if (collection && resources?.length === 0) {
    Content = <div>{placeholder}</div>;
  } else {
    Content = Array(10)
      .fill()
      .map(() => <Skeleton className={classes.row} />);
  }

  return (
    <div className={classes.root}>
      <AccordionListHeader collection={collection} />
      {Content}
      <AccordionListPagination />
    </div>
  );
}

AccordionList.propTypes = {
  classes: PropTypes.object.isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  AccordionContentComponent: PropTypes.object.isRequired,
  AccordionContentProps: PropTypes.object.isRequired,
};

AccordionList.defaultProps = {
  placeholder: <Placeholder />,
};

export default withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.facet.lightGray,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  row: {
    height: 96,
  },
}))(AccordionList);
